module.exports = __webpack_public_path__ + "static/media/HARD_RIGHT.61b07e41.svg";